const gaOperationCoreInstanceEn = {
  gaOperationCore: "GA Operation Core",
  requestedFor: "Requested For",
  assignee: "Assignee",
  progress: {
    title: "Progress",
  },
  tabs: {
    detail: "Detail",
    data: "Data",
    operationActivity: "Operation Activity",
  },
  task: {
    editSuccess: "Task updated successfully",
    approveSuccess: "Task approved successfully",
  },
  labelGenerationSuccess: "Label generation completed",
  labelGenerationSuccessDetail: "Generated {{count}} equipment labels",
  labelGenerationFailed: "Label generation failed",
  labelGenerationError: "An unexpected error occurred",

  printOptions: {
    printSettings: "Print settings",
    labelSize: "Label size",
    paperSize: "Paper size",
    margin: "Margin",
    layout: "Layout",
    assetTag: "Asset Tag",
    qrCode: "QR Code",
    equipmentName: "Equipment Name",
    none: "None",
    vertical: "Vertical",
    horizontal: "Horizontal",
    additionalContent: "Additional Content",
  },

  labelSpecs: {
    label65FacesA4: "65 Labels (A4)",
    label21FacesA4: "21 Labels (A4)",
    label12FacesA4: "12 Labels (A4)",
    label10FacesA4: "10 Labels (A4)",
    customLabel50Faces: "Custom 50 Labels",
  },
};

export default gaOperationCoreInstanceEn;
